class AnimatedCounter {
	static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-animatedcounter'
	static SELECTOR_CLASS_COUNTER = '.jtf__animatedcounter--counter'
	static CLASS_NAME_ACTIVE = 'jtf__animatedcounter--counter--active'
	static ATTR_SUFFIX = 'suffix'
	static ATTR_MIN = 'min'
	static ATTR_MAX = 'max'
	static ATTR_DURATION = 'duration'
	static PROP_DEFAULT_MIN = 0
	static PROP_DEFAULT_MAX = 100
	static PROP_DEFAULT_DURATION = 2
	static PROP_MILLISECONDS_PER_SECOND = 1000

	constructor( instance ) {
		this.instance = instance
		this.counters = instance.querySelectorAll( AnimatedCounter.SELECTOR_CLASS_COUNTER )
		this.scrollHandler = this.handleScroll.bind( this )
		this.onFirstLoad()
		this.scrollEvents()
	}

	animate( counter ) {
		const suffix = counter.dataset[ AnimatedCounter.ATTR_SUFFIX ] || ''
		const min = parseInt( counter.dataset[ AnimatedCounter.ATTR_MIN ] ) || AnimatedCounter.PROP_DEFAULT_MIN
		const max = parseInt( counter.dataset[ AnimatedCounter.ATTR_MAX ] ) || AnimatedCounter.PROP_DEFAULT_MAX
		const duration = parseFloat( counter.dataset[ AnimatedCounter.ATTR_DURATION ] ) || AnimatedCounter.PROP_DEFAULT_DURATION
		counter.classList.add( AnimatedCounter.CLASS_NAME_ACTIVE )

		const steps = max - min
		if ( steps === 0 ) {
			counter.innerHTML = min + suffix
			return
		}

		const intervalTime = (duration * AnimatedCounter.PROP_MILLISECONDS_PER_SECOND) / steps
		let current = min

		const interval = setInterval( () => {
			counter.innerHTML = current + suffix
			current++
			if ( current > max ) {
				clearInterval( interval )
			}
		}, intervalTime )
	}

	isInViewport( element ) {
		const rect = element.getBoundingClientRect()
		return (
			rect.top < window.innerHeight &&
			rect.bottom > 0 &&
			rect.left < window.innerWidth &&
			rect.right > 0
		)
	}

	onFirstLoad() {
		this.counters.forEach( ( counter ) => {
			if ( this.isInViewport( counter ) ) {
				if ( !counter.classList.contains( AnimatedCounter.CLASS_NAME_ACTIVE ) ) {
					this.animate( counter )
				}
			}
		} )
	}

	handleScroll() {
		let allAnimated = true

		this.counters.forEach( ( counter ) => {
			if ( this.isInViewport( counter ) ) {
				if ( !counter.classList.contains( AnimatedCounter.CLASS_NAME_ACTIVE ) ) {
					this.animate( counter )
				}
			}

			if ( !counter.classList.contains( AnimatedCounter.CLASS_NAME_ACTIVE ) ) {
				allAnimated = false
			}
		} )

		if ( allAnimated ) {
			window.removeEventListener( 'scroll', this.scrollHandler )
		}
	}

	scrollEvents() {
		window.addEventListener( 'scroll', this.scrollHandler )
	}
}

export default function init() {
	const blocks = document.querySelectorAll( AnimatedCounter.SELECTOR_CLASS_BLOCK )
	blocks.forEach( ( block ) => {
		new AnimatedCounter( block )
	} )
}
